import { TourStep } from '../../models/tour.model';

export const TERM_EXPLORER_TOUR: TourStep[] = [
  {
    title: 'Welcome to the Term Explorer',
    element: '.term-explorer',
    intro: `
        <p>Welcome to <b>Term Explorer</b> within Semeris Docs – your tool for efficient navigation and analysis of defined terms in documents.</p>
        <p>During this tour, we will guide you through:</p>
        <ul>
          <li><b>Searching</b> for terms and <b>sorting</b> your view</li>
          <li>Direct <b>navigation</b> to term definitions</li>
          <li>Gaining insights into <b>term frequency</b></li>
          <li>Spotting <b>new</b> and <b>uncommon terms</b> easily</li>
        </ul>
        <p><i>Ready to explore?</i></p>
      `,
  },
  {
    title: 'Accessing the Term Explorer Panel',
    element: '#deal-page-term-explorer-button',
    position: 'bottom',
    intro: `
        <p>Access the <b>Term Explorer</b> panel from the title bar on any deal page by clicking the <i class="material-icons">segment</i> icon.</p>
      `,
  },
  {
    title: 'Navigating the List of Defined Terms',
    element: '.term-explorer semeris-term-explorer-list',
    position: 'right',
    intro: `
        <p>This panel displays a <b>list of Defined Terms</b> from the document.</p>
        <p>Use this list to:</p>
        <ul>
          <li><b>View a term's definition</b> by clicking on it, which will navigate you to its location in the document.</li>
          <li><b>Compare terms across the market</b> by hovering over a term and clicking the <i class="material-icons">view_list</i> icon for <b>Market Compare</b>. This shows a term's definition in other documents.</li>
        </ul>
      `,
  },
  {
    title: 'Searching for Defined Terms',
    element: '.term-explorer semeris-term-explorer-list .term-explorer-list-actions',
    position: 'bottom',
    intro: `
      <p>When you begin typing in the <b>search box</b>, the list dynamically narrows down.</p>
    `,
  },
  {
    title: 'Sorting Defined Terms',
    element: '.term-explorer semeris-term-explorer-sort .sort-control',
    position: 'bottom',
    intro: `
        <p>Sort the list of terms using these controls by:</p>
        <ul>
          <li><b>Term</b> - alphabetically by the term's name</li>
          <li><b>Document Order</b> - by their appearance within the document</li>
          <li><b>Frequency</b> - by how frequently they are used in other documents</li>
        </ul>
      `,
  },
  {
    title: 'Interpreting Term Frequency',
    element: '.term-explorer semeris-term-explorer-list .list-item span.marker',
    position: 'bottom',
    intro: `
      <p>Each term features a <b>frequency marker</b>, a numerical and visual indicator of how often a term appears across various deals.</p>
      <p>Understanding <b>term frequency</b> is key. It is the number of times a term appears across different deals.</p>
      <p>To spot <b>unusual terms</b>, simply sort the list by frequency.</p>
      `,
  },
  {
    title: 'Understanding the Scope of Term Frequency',
    element: '.term-explorer semeris-deal-filter-selector',
    position: 'bottom',
    intro: `
      <p>Choose different Deal Filters to adjust the <b>scope</b> of term frequency calculation.</p>
      <p><b>Note!</b> Frequency calculations over large sets of deals may take more time.</p>
    `,
  },
  {
    title: 'Exporting Terms to Excel',
    element: '.term-explorer #term-explorer-menu-button',
    intro: `
      <p>For analysis in Excel, open the menu <i class="material-icons">more_vert</i> and select <b>Copy to Excel</b>.</p>
    `,
    position: 'bottom',
  },
  {
    title: 'Integration with Smart Blacklines',
    element: 'semeris-document-comparison-header #blackline-button',
    position: 'left',
    intro: `
        <p>When used with <b>Smart Blacklines</b>, Term Explorer highlights changes:</p>
        <ul>
          <li>New terms appear in <span style="color: blue; text-decoration: underline;">blue with an underline</span>.</li>
          <li>Deleted terms are shown with a <span style="color: red; text-decoration: line-through;">red strikethrough</span>.</li>
        </ul>
        <p>Click the <i class="material-icons">invert_colors</i> icon to filter for only new or deleted terms.</p>
        <p><b>Note!</b> Term Explorer marks new and removed terms but does not reflect phrasing changes. To review language modifications, click on a term.</p>
      `,
  },
  {
    title: 'Completing Your Term Explorer Tour',
    intro: `
        <p>You're now ready to navigate defined terms with ease.</p>
        <p>Term Explorer not only <b>enhances your review process</b> but also lets you quickly spot <b>new and uncommon terms</b> for sharper insights.</p>
        <p><i>Enjoy exploring defined terms with Semeris Docs!</i></p>
      `,
  },
];
